import React from 'react';
import {useChart} from '../hooks';
import styled from 'styled-components';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';


const StyledChartWrapper = styled.div`
    height: 480px;
    width: 100%;
`;

const istobe = []

const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

export default function ({data = [],
                          series = [],
                          save,
                          projectId,
                          chartId,
                          updateChart,
                          color}) {
    const [ref, chart] = useChart({
        data,
        "xAxes": [{
            "type": "CategoryAxis",
            "dataFields": {
                "category": "title",

            },
            "renderer": {
                "labels": {
                  "template": {
                    "disabled": "true"
                  }
                }
            }

        }],
        "yAxes": [{
            "type": "ValueAxis",
            "min": 0,
            "max": 100,
            'tooltipText': '{title}',
            "renderer": {
                "labels": {
                  "template": {
                    "disabled": "true"
                  }
                }
            }
        }],
        "series": [{
            "type": "LineSeries",
            "dataFields": {
              "categoryX": "country",
              "valueY": "visits"
            },
        }],
        "colors": {
          "list": [
            '#1c7ff4',
            '#ec407a',
            '#7e57c2',
            '#4caf50',
            '#ffeb3b',
            '#03a9f4',
            '#1c7ff4',
          ]
        }
    }, am4charts.XYChart);

    const [actions, setActions] = React.useState(null);
    const [openUpdate, setOpenUpdate] = React.useState(null);
    const [isToBe, setIsToBe] = React.useState({
      title: '',
    });
    const [activ,setActiv] = React.useState(true)
    const activCompany = series.length > 4
    const activData = data.length > 9

    const isToBeActiv = Object.values(data.map).includes(null)
    const listActiv = []
    data.forEach((item, i) => {

      console.log(Object.values(item).filter(i => typeof i !== 'string'), 'tobe')

      listActiv.push(
        Object.values(item).filter(i => typeof i !== 'string').reduce((sum, x) => sum + x)
      )
    });
    console.log('tobe', listActiv, listActiv.includes(0))

    const istobecompany = listActiv.includes(0)



    React.useEffect(
        () => {
            // console.log("!!!!!!!", chart);
            if (!chart) {
                return
            }

            const addBullet = s => {
                const bullet = s.bullets.create();
                bullet.stroke = am4core.color("#ffffff");
                bullet.strokeWidth = 3;
                bullet.opacity = 1; // initially invisible
                bullet.defaultState.properties.opacity = 1;
                // resize cursor when over
                bullet.cursorOverStyle = am4core.MouseCursorStyle.verticalResize;
                bullet.draggable = true;

                // add circle sprite to bullet
                const circle = bullet.createChild(am4core.Circle);
                circle.radius = 8;

                // while dragging
                bullet.events.on("drag", event => {
                    handleDrag(event);
                });

                bullet.events.on("dragstop", event => {
                    handleDrag(event);
                    // TODO: save dataa
                    const dataItem = event.target.dataItem;
                    dataItem.dataContext[dataItem.component.name] = dataItem.valueY;
                    // const name = dataItem.categories.categoryX;
                    // for (const item of chart.data.values) {
                    //     if (item[title] === name && item[])
                    // }
                    save({data: chart.data, series})
                });
            };

            const addSeries = title => {
                const s = chart.series.push(new am4charts.LineSeries());
                s.dataFields.valueY = title;
                s.dataFields.categoryX = "title";
                s.name = title;
                s.strokeWidth = 3;
                addBullet(s)
            };

            series.forEach(s => addSeries(s));

            function handleDrag(event) {
                const dataItem = event.target.dataItem;
                // convert coordinate to value
                let value = chart.yAxes.values[0].yToValue(event.target.pixelY);
                // set new value
                value = value > 100 ? 100 : value;
                value = value < 0 ? 0 : value;
                dataItem.valueY = value;
                // make column hover
            }



            window.chart = chart;
            setActions({
                addRow: (title, is) => e => {
                    const obj = {title};
                    chart.series.values.forEach((item, i) => {
                      // // console.log(item.name, item.name === [...istobe], [...istobe])
                      // console.log('chart.series.values',chart.series.values)
                      if (title === istobe) {
                        obj[item.name] = 50
                      } else {
                        obj[item.name] = null
                      }
                    })
                    // // console.log(isToBe)
                    chart.addData(obj)
                    save({data: chart.data, series, activ})
                    setOpen(false)
                    setValues({
                      title: '',
                      titleCompany: ''
                    })
                    setOpenToBeRow(false)
                },
                addSeries: (title, is, activ) => e => {
                        // Update data
                        for (let i = 0; i < chart.data.length; i++) {
                            chart.data[i][title] = chart.series.length*10;
                        }
                        // console.log('chart.series.values',chart.series.length, chart.series)
                        if (is === true) {
                          addSeries(title)
                          series.push(title);
                          chart.invalidateData();
                          istobe.push(title);
                          setIsToBe({'title': title})
                          save({data: chart.data, series, activ})
                          setOpenToBe(false)
                          setValues({
                            title: '',
                            titleCompany: ''
                          })
                          setActiv(false)


                          // // console.log('istobe',istobe)

                        }
                        else {
                          // console.log(is)
                          addSeries(title)
                          series.push(title);
                          chart.invalidateData();
                          save({data: chart.data, series, activ})

                          setValues({
                            title: '',
                            titleCompany: ''
                          })
                          setOpenToBe(false)
                        }

                },


            })
        },
        [chart]
    );

    const [open, setOpen] = React.useState(false);
    const [open2, setOpen2] = React.useState(false);
    const [openToBe, setOpenToBe] = React.useState(false);
    const [openToBeRow, setOpenToBeRow] = React.useState(false);

    const classes = useStyles();

    const [values, setValues] = React.useState({
        title: '',
        titleCompany: ''
    });

    const handleChange = name => event => {
        setValues({...values, [name]: event.target.value});
    };






    return (
        <>
        {actions && <div>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setOpenToBeRow(true)}
          >
              Add Factors to-be
          </Button>
          <Modal
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              className={classes.modal}
              open={open}
              onClose={() => setOpen(false)}
          >
              <div className={classes.paper}>
                  <h2 id="simple-modal-title">Add Factor</h2>
                  <form
                      className={classes.form}
                      noValidate autoComplete="off">
                      <TextField
                          id="title"
                          label="Name"
                          value={values.title}
                          onChange={handleChange('title')}/>
                  </form>
                  <br/>
                  <Button
                      variant="contained"
                      color="primary"
                      onClick={actions.addRow(values.title)}>
                      Ok
                  </Button>
              </div>
          </Modal>

          <Modal
              aria-labelledby="simple-modal-title"
              aria-describedby="simple-modal-description"
              className={classes.modal}
              open={openToBeRow}
              onClose={() => setOpenToBeRow(false)}
          >
              <div className={classes.paper}>
                  <h2 id="simple-modal-title">Add Factor To-be</h2>
                  <form
                      className={classes.form}
                      noValidate autoComplete="off">
                      <TextField
                          id="title"
                          label="Name"
                          value={values.title}
                          onChange={handleChange('title')}/>
                  </form>
                  <br/>
                  <Button
                      variant="contained"
                      color="primary"
                      disabled={values.title.length === 0 ? true : false}
                      onClick={actions.addRow(values.title,true)}>
                      Ok
                  </Button>
              </div>
          </Modal>

          <Button
            variant="outlined"
            color="primary"
            disabled={!istobecompany ? true : false}
            onClick={() => setOpenToBe(true)}
          >
              Add company To-Be
          </Button>
          <Modal
              aria-labelledby="simple-modal-title2"
              aria-describedby="simple-modal-description2"
              className={classes.modal}
              open={open2}
              onClose={() => setOpen2(false)}
          >
              <div className={classes.paper}>
                  <form
                      className={classes.form}
                      noValidate autoComplete="off">
                      <TextField
                          id="title"
                          label="Name"
                          value={values.titleCompany}
                          onChange={handleChange('titleCompany')}/>
                  </form>
                  <br/>
                  <Button
                      variant="contained"
                      color="primary"
                      disabled={values.title.length === 0 ? true : false}
                      onClick={actions.addSeries(values.titleCompany, false)}>
                      Ok
                  </Button>
              </div>
          </Modal>

          <Modal
              aria-labelledby="simple-modal-title2"
              aria-describedby="simple-modal-description2"
              className={classes.modal}
              open={openToBe}
              onClose={() => setOpenToBe(false)}
          >
              <div className={classes.paper}>
                  <h2 id="simple-modal-title2">Add company to-be</h2>
                  <form
                      className={classes.form}
                      noValidate autoComplete="off">
                      <TextField
                          id="title"
                          label="Name"
                          value={values.titleCompany}
                          onChange={handleChange('titleCompany')}/>
                  </form>
                  <br/>
                  <Button
                      variant="contained"
                      color="primary"
                      disabled={values.titleCompany.length === 0 ? true : false}
                      onClick={actions.addSeries(values.titleCompany, true, activ)}>
                        Ok
                  </Button>
              </div>
          </Modal>


          </div>}
          <StyledChartWrapper ref={ref}/>

          <Modal
              aria-labelledby="simple-modal-title2"
              aria-describedby="simple-modal-description2"
              className={classes.modal}
              open={openUpdate}
              onClose={() => setOpenUpdate(false)}
          >
              <div className={classes.paper}>
                  <h2 id="simple-modal-title2">Изменить </h2>

              </div>
          </Modal>
        </>
    )
}
